module.exports = __webpack_public_path__ + "img/9791156330318.8773ae19.jpg";